import React from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';

import {screens} from '../screens';
import {TabNavigator} from './TabNavigator';
import {ProtectedRoute} from './ProtectedRoute';

// Diekspor supaya bisa navigate secara imperatif dari luar tree React (mis. saat user
// tap push notification native — capacitorService.ts tidak berada di dalam context
// Router manapun, jadi tidak bisa pakai hook useNavigate biasa).
export const stack = createBrowserRouter([
  {
    path: '/',
    element: <screens.SignIn />,
  },
  {
    path: '/SignIn',
    element: <screens.SignIn />,
  },
  {
    path: '/SignUp',
    element: <screens.SignUp />,
  },
  {
    path: '/TenantSelect',
    element: <screens.TenantSelect />,
  },
  {
    path: '/VerifyYourPhoneNumber',
    element: <screens.VerifyYourPhoneNumber />,
  },
  {
    path: '/InvoiceSent',
    element: (
      <ProtectedRoute>
        <screens.InvoiceSent />
      </ProtectedRoute>
    ),
  },
  {
    path: '/FundTransfer',
    element: (
      <ProtectedRoute>
        <screens.FundTransfer />
      </ProtectedRoute>
    ),
  },
  {
    path: '/OpenNewLoan',
    element: (
      <ProtectedRoute>
        <screens.OpenNewLoan />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CardMenu',
    element: (
      <ProtectedRoute>
        <screens.CardMenu />
      </ProtectedRoute>
    ),
  },
  {
    path: '/ForgotPassword',
    element: <screens.ForgotPassword />,
  },
  {
    path: '/ResetPassword',
    element: <screens.ResetPassword />,
  },
  {
    path: '/CreateInvoice',
    element: (
      <ProtectedRoute>
        <screens.CreateInvoice />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Statistics',
    element: (
      <ProtectedRoute>
        <screens.Statistics />
      </ProtectedRoute>
    ),
  },
  {
    path: '/OpenDeposit',
    element: (
      <ProtectedRoute>
        <screens.OpenDeposit />
      </ProtectedRoute>
    ),
  },
  {
    path: '/OpenMoneybox',
    element: (
      <ProtectedRoute>
        <screens.OpenMoneybox />
      </ProtectedRoute>
    ),
  },
  {
    path: '/SignUpAccountCreated',
    element: <screens.SignUpAccountCreated />,
  },
  {
    path: '/ConfirmationCode',
    element: <screens.ConfirmationCode />,
  },
  {
    path: '/PaymentFailed',
    element: (
      <ProtectedRoute>
        <screens.PaymentFailed />
      </ProtectedRoute>
    ),
  },
  {
    path: '/PrivacyPolicy',
    element: <screens.PrivacyPolicy />,
  },
  {
    path: '/TransactionDetails',
    element: (
      <ProtectedRoute>
        <screens.TransactionDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: '/ChangePINCode',
    element: (
      <ProtectedRoute>
        <screens.ChangePINCode />
      </ProtectedRoute>
    ),
  },
  {
    path: '/IBANPayment',
    element: (
      <ProtectedRoute>
        <screens.IBANPayment />
      </ProtectedRoute>
    ),
  },
  {
    path: '/FAQ',
    element: <screens.FAQ />,
  },
  {
    path: '/EditPersonalInfo',
    element: (
      <ProtectedRoute>
        <screens.EditPersonalInfo />
      </ProtectedRoute>
    ),
  },
  {
    path: '/PaymentSuccess',
    element: (
      <ProtectedRoute>
        <screens.PaymentSuccess />
      </ProtectedRoute>
    ),
  },
  {
    path: '/OpenNewCard',
    element: (
      <ProtectedRoute>
        <screens.OpenNewCard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Payments',
    element: (
      <ProtectedRoute>
        <screens.Payments />
      </ProtectedRoute>
    ),
  },
  {
    path: '/MobilePayment',
    element: (
      <ProtectedRoute>
        <screens.MobilePayment />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CardDetails',
    element: (
      <ProtectedRoute>
        <screens.CardDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TopUpPayment',
    element: (
      <ProtectedRoute>
        <screens.TopUpPayment />
      </ProtectedRoute>
    ),
  },
  {
    path: '/NewPassword',
    element: <screens.NewPassword />,
  },
  {
    path: '/ForgotPasswordSentEmail',
    element: <screens.ForgotPasswordSentEmail />,
  },
  {
    path: '/Profile',
    element: (
      <ProtectedRoute>
        <screens.Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TabNavigator',
    element: (
      <ProtectedRoute>
        <TabNavigator />
      </ProtectedRoute>
    ),
  },
  {
    path: '/PersonalData',
    element: (
      <ProtectedRoute>
        <screens.PersonalData />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Task',
    element: (
      <ProtectedRoute>
        <screens.Task />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Activity',
    element: (
      <ProtectedRoute>
        <screens.Activity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Notification',
    element: (
      <ProtectedRoute>
        <screens.Notification />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CreateTask',
    element: (
      <ProtectedRoute>
        <screens.CreateTask />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CheckerTask',
    element: (
      <ProtectedRoute>
        <screens.CheckerTask />
      </ProtectedRoute>
    ),
  },
  {
    path: '/PreCheckReports',
    element: (
      <ProtectedRoute>
        <screens.PreCheckReports />
      </ProtectedRoute>
    ),
  },
  {
    path: '/PreCheckReportForm',
    element: (
      <ProtectedRoute>
        <screens.PreCheckReportForm />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TaskDetails',
    element: (
      <ProtectedRoute>
        <screens.TaskDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: '/EditTask',
    element: (
      <ProtectedRoute>
        <screens.EditTask />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TaskSubmission',
    element: (
      <ProtectedRoute>
        <screens.TaskSubmission />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TaskReview',
    element: (
      <ProtectedRoute>
        <screens.TaskReview />
      </ProtectedRoute>
    ),
  },
  {
    path: '/LeaveRequest',
    element: (
      <ProtectedRoute>
        <screens.LeaveRequest />
      </ProtectedRoute>
    ),
  },
  {
    path: '/LoanRequest',
    element: (
      <ProtectedRoute>
        <screens.LoanRequest />
      </ProtectedRoute>
    ),
  },
  {
    path: '/DocumentHistory',
    element: (
      <ProtectedRoute>
        <screens.DocumentHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CorrectionDetail',
    element: (
      <ProtectedRoute>
        <screens.CorrectionDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/LoanDetail',
    element: (
      <ProtectedRoute>
        <screens.LoanDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/LeaveHistory',
    element: (
      <ProtectedRoute>
        <screens.LeaveHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: '/LeaveDetails',
    element: (
      <ProtectedRoute>
        <screens.LeaveDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CreateActivity',
    element: (
      <ProtectedRoute>
        <screens.CreateActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Attendance',
    element: (
      <ProtectedRoute>
        <screens.Attendance />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Payslip',
    element: (
      <ProtectedRoute>
        <screens.Payslip />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Inbox',
    element: (
      <ProtectedRoute>
        <screens.Inbox />
      </ProtectedRoute>
    ),
  },
  {
    path: '/MarketingActivity',
    element: (
      <ProtectedRoute>
        <screens.MarketingActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CreateMarketingActivity',
    element: (
      <ProtectedRoute>
        <screens.CreateMarketingActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/DetailMarketingActivity',
    element: (
      <ProtectedRoute>
        <screens.DetailMarketingActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/EventActivity',
    element: (
      <ProtectedRoute>
        <screens.EventActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CreateEventActivity',
    element: (
      <ProtectedRoute>
        <screens.CreateEventActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/DetailEventActivity',
    element: (
      <ProtectedRoute>
        <screens.DetailEventActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/SurveyActivity',
    element: (
      <ProtectedRoute>
        <screens.SurveyActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CreateSurveyActivity',
    element: (
      <ProtectedRoute>
        <screens.CreateSurveyActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/DetailSurveyActivity',
    element: (
      <ProtectedRoute>
        <screens.DetailSurveyActivity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TravelExpenseForm',
    element: (
      <ProtectedRoute>
        <screens.TravelExpenseForm />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TravelExpenseDetail',
    element: (
      <ProtectedRoute>
        <screens.TravelExpenseDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TravelExpenseRecapForm',
    element: (
      <ProtectedRoute>
        <screens.TravelExpenseRecapForm />
      </ProtectedRoute>
    ),
  },
  {
    path: '/TimeSheetForm',
    element: (
      <ProtectedRoute>
        <screens.TimeSheetForm />
      </ProtectedRoute>
    ),
  },
  {
    path: '/ChatRoom',
    element: (
      <ProtectedRoute>
        <screens.ChatRoom />
      </ProtectedRoute>
    ),
  },
  {
    path: '/survey/:token',
    element: <screens.PublicSurvey />,
  },
  {
    path: '/Contacts',
    element: (
      <ProtectedRoute>
        <screens.Contacts />
      </ProtectedRoute>
    ),
  },
  {
    path: '/CallScreen',
    element: (
      <ProtectedRoute>
        <screens.CallScreen />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <screens.NotFound />,
  },
  // {
  //   path: '/Schedule',
  //   element: (
  //     <ProtectedRoute>
  //       <screens.Schedule />
  //     </ProtectedRoute>
  //   ),
  // },
]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
